// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__b165J","col":"styles_col__2asDX"};